/* global FormData */
import React, { useContext, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import ErrorMessage from 'components/ErrorMessage';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { AiFillCamera } from 'react-icons/ai';
import OImage from 'components/reusable/OImage';
import OButton from 'components/reusable/OButton';
import { apiPut, apiPost } from '../../utils/apiFetch';
import apiPath from '../../utils/apiPath';
import useToastContext from 'hooks/useToastContext';
import { FaRegFilePdf } from 'react-icons/fa';
import AuthContext from 'context/AuthContext';
const SliderSettingEdit = ({ bannerData, setEditModal, getAllBanners, setBannerItem }) => {
  const [profilePicError, setProfilePicError] = useState('');
  const profilePicRef = useRef();
  const pdfRef = useRef();
  const { t } = useTranslation();
  const notification = useToastContext();
  const [bannerDataLocal, setBannerData] = useState(bannerData);
  const { defaultCountry } = useContext(AuthContext);

  const handleDataChange = ({ target }) => {
    if (target.name === 'pdf') {
      setBannerData((prev) => ({ ...prev, pdfFileName: target?.files[0]?.name }));
    }

    if (
      (target.name === 'bannerImage' || target.name === 'pdf') &&
      !validateFiles(target.files[0], target.name)
    )
      return;
    if (target.name === 'bannerImage' || target.name === 'pdf') {
      setBannerData((prev) => ({ ...prev, [target.name]: target.files[0] }));
    } else {
      setBannerData((prev) => ({ ...prev, [target.name]: target.value }));
    }
  };
  const {
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    shouldFocusError: true,
  });

  const validateFiles = (file, name) => {
    let picError = '';
    let supportedTypes;

    switch (name) {
      case 'bannerImage':
        supportedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        break;

      case 'pdf':
        supportedTypes = ['application/pdf'];
        break;

      default:
        break;
    }

    if (!isEmpty(supportedTypes.includes(file?.type))) {
      switch (name) {
        case 'bannerImage':
          picError = 'Only jpeg, jpg and png are supported.';
          break;

        case 'pdf':
          picError = 'Only pdf files are supported.';
          break;

        default:
          break;
      }
    }

    if (picError) {
      setProfilePicError(picError);
      return false;
    } else {
      setProfilePicError('');
      return true;
    }
  };
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append('description', bannerDataLocal.description);
      formData.append('descriptionAr', bannerDataLocal.descriptionAr);
      formData.append('bannerImage', bannerDataLocal.bannerImage);
      formData.append('pdf', bannerDataLocal.pdf);
      formData.append('category', bannerDataLocal.category);
      formData.append('pdfFileName', bannerDataLocal.pdfFileName);
      let result;

      if (!isEmpty(bannerData)) {
        const path = apiPath.sliderSetting + '/' + bannerData._id;
        result = await apiPut(path, formData);
      } else {
        const path = apiPath.sliderSetting;
        result = await apiPost(path, formData);
      }

      if (result?.data?.success) {
        setEditModal(false);
        setBannerData(null)
        setBannerItem({})
        getAllBanners();
        notification.success(result.data.message);
      } else {
        notification.error(result.data.message);
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };
  return (
    <div>
      <>
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6  w-full max-w-[1150px] mx-auto">
            <div className="sm:py-4 sm:px-2 py-8 px-7 ">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">
                    {t('O_SAVE_SLIDER_SETTINGS')}
                  </h3>
                  <button
                    className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                    onClick={() => setEditModal(false)}
                  >
                    <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                      ×
                    </span>
                  </button>
                </div>
                <form onSubmit={onSubmit} method="post">
                  <div className="relative p-6 flex-auto">
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                      <div>
                        <div className="py-4 flex justify-center">
                          <div className="relative">
                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white w-30">
                              {!bannerDataLocal?.bannerImage ? (
                                <span
                                  className="flex align-center"
                                  onClick={() =>
                                    profilePicRef?.current?.click()
                                  }
                                >
                                  {' '}
                                  {t('BANNER_UPLOAD')} <AiFillCamera />{' '}
                                </span>
                              ) : (
                                <span className="flex align-center">
                                  {' '}
                                  {t('BANNER_UPLOAD')}
                                </span>
                              )}
                            </label>
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg"
                              name="bannerImage"
                              ref={profilePicRef}
                              onChange={handleDataChange}
                              className="hidden"
                            />

                            <div className="relative">
                              {bannerDataLocal?.bannerImage && (
                                <OImage
                                  src={
                                    typeof bannerDataLocal?.bannerImage ===
                                    'object'
                                      ? URL.createObjectURL(
                                          bannerDataLocal?.bannerImage
                                        )
                                      : bannerDataLocal?.bannerImage
                                  }
                                  fallbackUrl="/images/user.png"
                                  className="w-24 h-24 m-auto"
                                  alt=""
                                  style={{ borderRadius: '50%' }}
                                />
                              )}

                              {bannerDataLocal?.bannerImage && (
                                <AiFillCamera
                                  className=" bg-gray-100  absolute w-4 rounded-xl cursor-pointer "
                                  style={{
                                    width: '1.5rem',
                                    height: '1.5rem',
                                    bottom: '0',
                                    right: '20px',
                                    background: '',
                                    padding: '1px',
                                  }}
                                  onClick={() =>
                                    profilePicRef?.current?.click()
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="text-center mt-4">
                          <ErrorMessage message={profilePicError} />
                        </div>
                      </div>
                      {defaultCountry === 'sa' && (
                        <>
                          {/* Pdf Upload Section  */}
                          <div>
                            <div className="py-4 flex justify-center">
                              <div className="relative">
                                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white w-30">
                                  {!bannerDataLocal?.pdf ? (
                                    <span
                                      className="flex align-center"
                                      onClick={() => pdfRef?.current?.click()}
                                    >
                                      {' '}
                                      {t('PDF_UPLOAD')} <FaRegFilePdf />
                                    </span>
                                  ) : (
                                    <span className="flex align-center">
                                      {' '}
                                      {t('PDF_UPLOAD')}
                                    </span>
                                  )}
                                </label>
                                <input
                                  type="file"
                                  accept="application/pdf"
                                  name="pdf"
                                  ref={pdfRef}
                                  onChange={handleDataChange}
                                  className="hidden"
                                />

                                {bannerDataLocal?.pdf && (
                                  <div
                                    onClick={() => pdfRef?.current?.click()}
                                    className="relative flex items-center gap-1 cursor-pointer "
                                  >
                                    <FaRegFilePdf
                                      color="black"
                                      className="w-4 rounded-xl "
                                      style={{
                                        width: '1.2rem',
                                        height: '2rem',
                                        padding: '1px',
                                        margin: '0px auto',
                                      }}
                                    />
                                    <span className="truncate overflow-hidden max-w-[200px]">
                                      {bannerDataLocal?.pdfFileName}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="text-center mt-4">
                              <ErrorMessage message={profilePicError} />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="px-2">
                        <div className="mb-6">
                          <label
                            htmlFor="address"
                            className="peer-focus:font-normal block text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform"
                          >
                            {t('O_SELECT_CATEGORY')}
                          </label>
                          <select
                            name="category"
                            className="border-2 rounded-lg py-1 px-3"
                            onChange={handleDataChange}
                            value={bannerDataLocal.category}
                          >
                            <option value="">{t('O_SELECT_CATEGORY')}</option>
                            <option value="certificate">
                              {t('CERTIFICATE')}
                            </option>
                            <option value="award">{t('AWARD')}</option>
                          </select>
                          <ErrorMessage message={errors?.category?.message} />
                        </div>
                      </div>
                      <div className="px-2">
                        <div className="relative z-0 mb-6 w-full group">
                          <textarea
                            name="description"
                            value={bannerDataLocal.description}
                            onChange={handleDataChange}
                            id="description"
                            placeholder=" "
                            className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer"
                          />
                          <label
                            htmlFor="address"
                            className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                          >
                            {t('O_BANNER_DESCRIPTION')}
                          </label>
                          <ErrorMessage
                            message={errors?.description?.message}
                          />
                        </div>
                      </div>
                      <div className="px-2">
                        <div className="relative z-0 mb-6 w-full group">
                          <textarea
                            name="descriptionAr"
                            value={bannerDataLocal?.descriptionAr}
                            onChange={handleDataChange}
                            id="descriptionAr"
                            placeholder=" "
                            className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer"
                          />
                          <label
                            htmlFor="address"
                            className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                          >
                            {t('O_BANNER_DESCRIPTION') + t('O_ARABIC')}
                          </label>
                          <ErrorMessage
                            message={errors?.descriptionAr?.message}
                          />
                        </div>
                      </div>
                    </div>
                    <OButton
                      label={<>{t('O_SAVE')} </>}
                      type="button"
                      onClick={onSubmit}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </>
    </div>
  );
};

export default SliderSettingEdit;
